import { getFirstChar, getLastChar } from '@/utils/common';
import type { Directive, DirectiveBinding } from 'vue';

// 取字符串的最后一位如果没有就给-
export const lastChar = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.textContent = getLastChar(binding.value);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.textContent = getLastChar(binding.value);
  }
};
// 取字符串的第一位如果没有就给-
export const firstChar = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    el.textContent = getFirstChar(binding.value);
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    el.textContent = getFirstChar(binding.value);
  }
};

//重复提交
interface ElType extends HTMLElement {
  __handleClick__: () => void;
  disabled: boolean;
}

export const clickThrottle: Directive = {
  mounted(el: ElType, binding) {
    const { value } = binding;
    if (typeof value !== 'function') {
      throw new Error('v-click-throttle must be a function');
    }

    // 保存原始点击事件处理函数
    el.__handleClick__ = value;

    // 创建节流函数
    let timer: ReturnType<typeof setTimeout> | null = null;
    const throttle = async () => {
      if (timer) return;

      try {
        // 禁用按钮
        el.disabled = true;

        // 执行原始点击事件，保持正确的上下文
        const result = el.__handleClick__.call(binding.instance);

        // 如果是Promise，等待其完成
        if (result instanceof Promise) {
          await result;
        }

        // 设置定时器
        timer = setTimeout(() => {
          // 启用按钮
          el.disabled = false;
          timer = null;
        }, 2000); // 2秒后恢复
      } catch (error) {
        // 发生错误时也要恢复按钮状态
        el.disabled = false;
        timer = null;
        throw error;
      }
    };

    // 绑定点击事件
    el.addEventListener('click', throttle);
  },
  unmounted(el: ElType) {
    // 移除事件监听
    el.removeEventListener('click', el.__handleClick__);
  }
};
